'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var PropTypes = require('prop-types');
var index = require('../../../utilities/GatsbyLink/index.js');
var MediaListItem = require('../MediaListItem/MediaListItem.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);
var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var MediaListItemImage = function MediaListItemImage(props) {
  var alt = props.alt,
    empty = props.empty,
    href = props.href,
    image = props.image,
    subtitle = props.subtitle,
    title = props.title,
    sectionTitle = props.sectionTitle;
  var renderImage = function renderImage() {
    return /*#__PURE__*/React__default.default.createElement("div", {
      className: "div-img"
    }, /*#__PURE__*/React__default.default.createElement("div", {
      className: "lanl-image-container"
    }, image && !empty ? /*#__PURE__*/React__default.default.createElement(index.default, {
      href: href,
      className: "image-link rollover",
      "aria-label": alt
    }, /*#__PURE__*/React__default.default.createElement("img", {
      alt: alt,
      src: image,
      loading: "lazy",
      width: "250",
      height: "200"
    })) : /*#__PURE__*/React__default.default.createElement("img", {
      alt: alt,
      src: image,
      loading: "lazy",
      width: "250",
      height: "200"
    })));
  };
  return /*#__PURE__*/React__default.default.createElement(MediaListItem.MediaListItem, {
    className: "lanl-media-list-item-image",
    href: href,
    title: title,
    subtitle: subtitle,
    empty: empty,
    sectionTitle: sectionTitle
  }, renderImage());
};
MediaListItemImage.defaultProps = {};
MediaListItemImage.propTypes = {
  alt: PropTypes__default.default.string.isRequired,
  href: PropTypes__default.default.string.isRequired,
  image: PropTypes__default.default.string.isRequired,
  title: PropTypes__default.default.string.isRequired,
  empty: PropTypes__default.default.bool,
  sectionTitle: PropTypes__default.default.string,
  subtitle: PropTypes__default.default.string
};

exports.MediaListItemImage = MediaListItemImage;
exports.default = MediaListItemImage;
//# sourceMappingURL=MediaListItemImage.js.map
